import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import './assets/css/tailwind.css';
import pt from './locales/pt.json';
import en from './locales/en.json';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

Vue.prototype.$toast = iziToast;
Vue.use(VueI18n);

// Idiomas suportados
const supportedLangs = ['pt', 'en'];

// Tenta pegar idioma salvo
const savedLang = localStorage.getItem('idioma');

// Idioma do navegador
const browserLang = navigator.language.split('-')[0];

// Define idioma final
let locale = 'pt';

if (savedLang && supportedLangs.includes(savedLang)) {
  locale = savedLang;
} else if (supportedLangs.includes(browserLang)) {
  locale = browserLang;
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'pt',
  messages: { pt, en },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
